export enum ErrorCode {
    LEAVE_SCHEDULE_NOT_FOUND ='LS004404',
    VALIDATION_ERROR = 'LS002400'
}